import { Link } from "react-router-dom";
import type { Special } from "@/mocks/videos";

interface SpecialCardProps {
  special: Special;
  index?: number;
}

export default function SpecialCard({ special, index = 0 }: SpecialCardProps) {
  return (
    <Link
      to={`/special/${special.id}`}
      data-product-shop="special"
      style={{ animationDelay: `${index * 70}ms` }}
      className="group relative block rounded-lg overflow-hidden bg-foreground-950 h-64 md:h-72 animate-fade-up cursor-pointer"
    >
      <img
        src={special.cover}
        alt={`${special.title} - 亲吻视频专题`}
        title={`${special.title} - 亲嘴视频专题`}
        className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent" />
      <div className="relative z-10 h-full flex flex-col justify-end p-5 md:p-6">
        <span className="self-start px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-label mb-3">
          专题合集
        </span>
        <h3 className="font-heading text-xl md:text-2xl text-background-50 mb-2">
          {special.title}
        </h3>
        <p className="text-sm text-background-200/85 leading-relaxed line-clamp-2">
          {special.intro}
        </p>
        <span className="mt-4 flex items-center gap-1 text-sm text-primary-200 font-medium">
          查看合集
          <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
        </span>
      </div>
    </Link>
  );
}